/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * @class GridDOMProvider
 * @hideconstructor
 * @classdesc Implements DOMProviderAPI
 */
define([
	'jquery',
	'./api/DOMProviderAPI',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], ($, DomProviderAPI, APIFactory) => {
	class GridDOMProvider {
		constructor(options) {
			this._domNode = options.features.ContentViewDOM.getNode();
			this.liveWidgetDOM = options.features.LiveWidgetDOM;
			this.visualization = options.features.Visualization;
			const type = this.visualization.getType();
			if (type === 'Crosstab' || type === 'List'){
				this.liveWidgetDOM.registerProvider(this.getAPI());
			}
		}
		getAPI() {
			if (!this._api) {
				this._api =  APIFactory.createAPI(this, [DomProviderAPI]);
			}
			return this._api;
		}
		/**
		 * @implements DomProviderAPI.getUIJSON
		 */
		getUIJSON() {
			const cols = [];
			$(this._domNode).find('.grid-fixed-row-cell, .top-left-grid-cell').each((idx, col)=>{
				const $colHeader = $(col);
				cols.push({
					value: $colHeader.text(),
					useValue: $colHeader.attr('useValue') && $colHeader.attr('useValue').split('->'),
					color: $colHeader.css('color'),
					row: Number($colHeader.attr('row')),
					col: Number($colHeader.attr('col')),
					isMeasure: $colHeader.attr('measure') === 'true',
					isSummary: $colHeader.hasClass('summary')
				});
			});
			const rows = [];
			$(this._domNode).find('.grid-fixed-column-cell').each((idx, row)=>{
				const $rowHeader = $(row);
				rows.push({
					value: $rowHeader.text(),
					useValue: $rowHeader.attr('useValue').split('->'),
					color: $rowHeader.css('color'),
					row: Number($rowHeader.attr('row')),
					col: Number($rowHeader.attr('col')),
					isMeasure: $rowHeader.attr('measure') === 'true',
					isSummary: $rowHeader.hasClass('summary')
				});
			});
			const values = [];
			$(this._domNode).find('.grid-data-cell').each((idx, cell)=>{
				const $cell = $(cell);
				const $shape = $cell.find(`svg > use`);
				const backgroundColor = $cell.css('background-color');
				const backgroundColorTokens = backgroundColor.split(',');
				const tupleValue = $cell.attr('tuple') ? $cell.attr('tuple').split('->') : undefined;
				values.push({
					value: $cell.find('.dashboard-text-cell').text(),
					tuple: tupleValue,
					color: $cell.css('color'),
					'background-color': backgroundColor,
					shape: $shape.attr('xlink:href'),
					row: Number($cell.attr('row')),
					col: Number($cell.attr('col')),
					isSummary: $cell.hasClass('summary'),
					opacity: parseFloat(backgroundColorTokens[backgroundColorTokens.length-1].split(')')[0])
				});
			});
			return {
				cols: cols,
				rows: rows,
				values: values
			};
		}
	}
	return GridDOMProvider;
});